import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

const Date = ({ value, ...formattedDateProps }) => (
  <FormattedDate value={value} year='2-digit' month='2-digit' day='2-digit' {...formattedDateProps} />
);

Date.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default Date;
